import React, { useState, useEffect } from "react";

import { useParams } from "react-router-dom";
import { useGlobalContext } from "context/GlobalContext";
import { filterTokenByType } from "helpers/token";

import { fetchTokens } from "api";
import { getUser } from "hooks/storageUtils";

const AllTokenData = () => {
  const { id } = useParams();
  const { setLoading } = useGlobalContext();

  const [tokens, setTokens] = useState([]);
  const [themeTokens, setThemeTokens] = useState([]);

  useEffect(() => {
    const fetchDesignSystem = async () => {
      try {
        setLoading(true);
        const user = getUser();
        const { core, theme } = await fetchTokens(user.id, id, "");
        setTokens(core);
        setThemeTokens(theme);
      } catch (error) {
        console.error("Failed to fetch design system", error);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchDesignSystem();
    }
  }, [id]);

  // const colorData = filterTokenByType(tokens, "color");
  const typographyData = filterTokenByType(tokens, "typography");
  const spacingData = filterTokenByType(tokens, "spacing");
  const elevationData = filterTokenByType(tokens, "boxShadow");
  const borderRadiusData = filterTokenByType(tokens, "borderRadius");
  const sizingData = filterTokenByType(tokens, "sizing");
  const fontData = [
    ...filterTokenByType(tokens, "fontFamilies"),
    ...filterTokenByType(tokens, "fontSizes"),
    ...filterTokenByType(tokens, "fontWeights"),
    ...filterTokenByType(tokens, "lineHeights"),
    ...filterTokenByType(tokens, "letterSpacing"),
    ...filterTokenByType(tokens, "paragraphSpacing"),
    ...filterTokenByType(tokens, "textDecoration"),
    ...filterTokenByType(tokens, "textCase"),
  ];
  const borderWidthData = filterTokenByType(tokens, "borderWidth");
  const themeTokenData = filterTokenByType(themeTokens, "color");

  return [
    {
      id: 1,
      title: "Tokens",
      sub_heading: "Color",
      type: "color",
      colorData: themeTokenData,
    },
    {
      id: 2,
      title: "Tokens",
      sub_heading: "Typography",
      type: "typography",
      colorData: typographyData,
    },
    {
      id: 3,
      title: "Tokens",
      sub_heading: "Spacing",
      type: "spacing",
      colorData: spacingData,
    },
    {
      id: 4,
      title: "Tokens",
      sub_heading: "Border Radius",
      type: "borderRadius",
      colorData: borderRadiusData,
    },
    {
      id: 5,
      title: "Tokens",
      sub_heading: "Elevation",
      type: "boxShadow",
      colorData: elevationData,
    },
    {
      id: 6,
      title: "Tokens",
      sub_heading: "Sizing",
      type: "sizing",
      colorData: sizingData,
    },
    {
      id: 7,
      title: "Tokens",
      sub_heading: "Font",
      type: "font",
      colorData: fontData,
    },
    {
      id: 8,
      title: "Tokens",
      sub_heading: "Border Width",
      type: "borderWidth",
      colorData: borderWidthData,
    },
  ];
};

export default AllTokenData;
